<div class="max-w-[420px] w-full relative">
  @if (config.showCloseButton) {
    <button
      mat-icon-button
      mat-dialog-close
      (click)="onCancel()"
      class="absolute! top-2 right-2 [&_mat-icon]:text-[20px]! [&_mat-icon]:w -[20px]! [&_mat-icon]:h-[20px]!">
      <mat-icon>close</mat-icon>
    </button>
  }

  <h5 class="pl-7 pt-7 pb-3 text-lg font-semibold">
    {{ config.title | translate }}
  </h5>

  <div class="mt-0 text-sm leading-5 text-[var(--mat-sys-on-surface)] pl-7!" [ngClass]="config.bodyClass">
    {{ config.content | translate }}
  </div>

  <div mat-dialog-actions class="mt-6 flex items-center justify-end gap-3" style="border-top: none">
    @if (!config.hideCancelButton) {
      <button
        mat-stroked-button
        mat-dialog-close
        (click)="onCancel()"
        class="rounded-md relative z-10 h-[36px]!"
        [ngStyle]="{ color: config.cancelColor, borderColor: config.cancelColor }">
        {{ (config.cancelText || 'cancel') | translate }}
      </button>
    }
    <button
      mat-flat-button
      mat-dialog-close
      cdkFocusInitial
      (click)="onConfirm()"
      class="rounded-md relative z-0 h-[36px]!"
      [ngStyle]="{ backgroundColor: config.confirmColor }">
      {{ (config.confirmText || 'Ok') | translate }}
    </button>
  </div>
</div>
